module.exports = __webpack_public_path__ + "media/images/emblems/Romoos_LU-9e7fc6f9d1eab100458022748035be6e.png";